import { qformElements } from './_quform-elements.js';

export default function initQuformPageTransition() {
    const $ = jQuery;

    const formMutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            console.log(mutation);
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                // ページ切り替え時の共通処理
                // const scrollElement = document.scrollingElement || document.documentElement; //スクロールする要素（ブラウザによって違う）

                setTimeout(() => {
                    const quformContainer = qformElements.quformContainer;
                    if (quformContainer) {
                        const formScrollTop = quformContainer.getBoundingClientRect().top + window.scrollY;
                        const headerHeight = document.querySelector('.l-header').offsetHeight;

                        window.scrollTo({
                            top: formScrollTop - headerHeight,
                            behavior: 'smooth'
                        });
                    }
                }, 500);

                // Step1のページクラスの監視
                const formStep1 = qformElements.formStep1;
                if (formStep1) {
                    const hasSpecificClass = formStep1.classList.contains(qformElements.headerObserveClassName);

                    if (hasSpecificClass) {
                        // クラスが追加されたときの処理
                        console.log('クラスが追加されました');
                        formStep1.dispatchEvent(new CustomEvent('classAdded', {
                            detail: { className: qformElements.headerObserveClassName }
                        }));
                    } else {
                        // クラスが削除されたときの処理
                        console.log('クラスが削除されました');
                        formStep1.dispatchEvent(new CustomEvent('classRemoved', {
                            detail: { className: qformElements.headerObserveClassName }
                        }));
                    }
                }
            }
        });
    });

    // formMutationObserverで監視開始
    qformElements.quformPages.forEach((page) => {
        formMutationObserver.observe(page, {
            attributes: true,
            attributeFilter: ['class']
        });
    });

    // formMutationObserverのclassAddedイベントを監視
    const formStep1 = qformElements.formStep1;
    if (formStep1) {
        formStep1.addEventListener('classAdded', (event) => {
            console.log('クラスが追加されました', event.detail.className);
            const contactPageHeader = qformElements.contactPageHeader;
            const quformContainer = qformElements.quformContainer;
            if (contactPageHeader) {
                if (quformContainer && window.getComputedStyle(quformContainer).display === 'none') {
                    contactPageHeader.classList.add('is-not-first-step');
                } else {
                    contactPageHeader.classList.remove('is-not-first-step');
                }
            }
        });

        // formMutationObserverのclassRemovedイベントを監視
        formStep1.addEventListener('classRemoved', (event) => {
            console.log('クラスが削除されました', event.detail.className);
            const contactPageHeader = qformElements.contactPageHeader;
            if (contactPageHeader) {
                contactPageHeader.classList.add('is-not-first-step');
            }
        });
    }
}